<template>
  <div class="process-steps-section">
    <div class="container-fluid px-0">
      <div class="row justify-content-center m-0">
        <div class="col-12 text-center">
          <h2 class="section-title-process">DARBO PROCESAS</h2>
          <div class="section-divider-process"></div>
          <p class="process-subtitle">Kaip mes dirbame su jumis</p>
        </div>
      </div>

      <div class="row justify-content-center m-0 steps-container-process">
        <div class="col-md-4 mb-4">
          <div class="step-card-process">
            <div class="step-number-process">01</div>
            <h6 class="step-title-process">Konsultacija</h6>
            <p class="step-text-process">Aptariame jūsų projektą, vertiname darbų apimtį ir pateikiame preliminarų pasiūlymą.</p>
          </div>
        </div>
        <div class="col-md-4 mb-4">
          <div class="step-card-process">
            <div class="step-number-process">02</div>
            <h6 class="step-title-process">Planavimas</h6>
            <p class="step-text-process">Paruošiame detalų darbo planą, suderiname laiką ir paruošiame reikalingą techniką.</p>
          </div>
        </div>
        <div class="col-md-4 mb-4">
          <div class="step-card-process">
            <div class="step-number-process">03</div>
            <h6 class="step-title-process">Įgyvendinimas</h6>
            <p class="step-text-process">Atliekame darbus profesionaliai, greitai ir tvarkingai. Informuojame apie progresą.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProcessSteps"
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,500;1,300&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300&display=swap');

.process-steps-section {
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  padding: 80px 20px;
}

.section-title-process {
  font-family: 'Montserrat', sans-serif;
  font-size: clamp(1.75rem, 4vw, 2.5rem);
  font-weight: 800;
  color: #1a1a1a;
  margin-bottom: 20px;
  letter-spacing: -0.02em;
}

.section-divider-process {
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, #dc3545, #ff6b6b);
  border-radius: 2px;
  margin: 0 auto 20px;
}

.process-subtitle {
  font-family: 'Open Sans', sans-serif;
  font-size: 1.1rem;
  color: #6c757d;
  margin-bottom: 50px;
}

.steps-container-process {
  padding: 20px 0;
}

.step-card-process {
  background: white;
  border-radius: 16px;
  padding: 40px 30px;
  height: 100%;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  border: 1px solid #f0f0f0;
  position: relative;
  overflow: hidden;
  text-align: center;
}

.step-card-process::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(180deg, #dc3545, #ff6b6b);
  transform: scaleY(0);
  transition: transform 0.3s ease;
}

.step-card-process:hover::before {
  transform: scaleY(1);
}

.step-card-process:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
  border-color: #dc3545;
}

.step-number-process {
  font-family: 'Montserrat', sans-serif;
  font-size: 4rem;
  font-weight: 800;
  background: linear-gradient(135deg, #dc3545, #ff6b6b);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  line-height: 1;
  margin-bottom: 20px;
  opacity: 0.2;
  transition: opacity 0.3s ease;
}

.step-card-process:hover .step-number-process {
  opacity: 0.3;
}

.step-title-process {
  font-family: 'Montserrat', sans-serif;
  font-size: 1.5rem;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 16px;
}

.step-text-process {
  font-family: 'Open Sans', sans-serif;
  font-size: 1rem;
  line-height: 1.7;
  color: #6c757d;
  margin: 0;
}

@media (max-width: 768px) {
  .process-steps-section {
    padding: 60px 15px;
  }
  
  .step-card-process {
    padding: 30px 24px;
  }
  
  .step-number-process {
    font-size: 3rem;
  }
}
</style>

